import { createSlice } from "@reduxjs/toolkit";

// Define the initial state using that type
const initialState: IUserGroupsState = {
  data: null,
  pageSize: 0,
  pageNumber: 0,
  totalCount: 0,
  showLoading: {
    sourceAction: "",
    state: false,
  },
  isLoading: false,
  isSuccess: false,
  aliasSGDetails: null,
  securityGroupsDetails: null,
  sgUsersDetails: null,
};

export const userGroupsSlice = createSlice({
  name: "userGroups",
  // `createSlice` will infer the state type from the `initialState` argument
  initialState,
  reducers: {
    setLoading: (state, action) => {
      const { sourceAction, isLoading, isSuccess } = action.payload;
      state.showLoading = {
        sourceAction: sourceAction,
        state: true,
      };
      state.isLoading = isLoading ? isLoading : false;
      state.isSuccess = isSuccess ? isSuccess : false;
    },

    resetLoading: (state, action) => {
      const { isLoading, isSuccess } = action.payload;
      state.showLoading = {
        sourceAction: "",
        state: false,
      };
      state.isLoading = isLoading ? isLoading : false;
      state.isSuccess = isSuccess ? isSuccess : false;
    },

    replaceUserGroup: (state, action) => {
      const { data, pageSize, pageNumber, totalCount } = action.payload;
      state.data = data;
      state.pageSize = pageSize;
      state.pageNumber = pageNumber;
      state.totalCount = totalCount;
    },

    addUserGroup: (state, action) => {
      const newItem = action.payload.data;
      if (state.data && state.data.length > state.pageSize) {
        state.data.pop();
      }
      state.data = state.data ? [newItem, ...state.data] : [newItem];
      state.totalCount = state.totalCount + 1;
    },

    updateUserGroup: (state, action) => {
      const { data } = action.payload;
      if (state.data) {
        const index = state.data.findIndex((item) => item.id === data.id);
        if (index !== -1) {
          state.data[index] = data;
        }
      }
      state.securityGroupsDetails = data;
    },
    setAliasSGDetails: (state, action) => {
      const { data, pageSize, pageNumber, totalCount } = action.payload;
      state.aliasSGDetails = data;
      state.pageSize = pageSize;
      state.pageNumber = pageNumber;
      state.totalCount = totalCount;
    },
    deleteSecurityGroup: (state, action) => {
      const userGroupsToRemove: IUserGroups = action.payload.data;
      const newUserGroupsData =
        state.data &&
        state.data.filter((userGroups: IUserGroups) => {
          return userGroups.id !== userGroupsToRemove.id;
        });
      state.data = newUserGroupsData;
      state.totalCount = state.totalCount - 1;
    },
    setsecurityGroupDetails: (state, action) => {
      state.securityGroupsDetails = action.payload.data;
    },
    setSGUserDetails: (state, action) => {
      state.sgUsersDetails = action.payload.data;
    },
    resetSecurityGroupsDataAction: (state) => {
      state.data = null;
      state.aliasSGDetails = null;
      state.totalCount = 0;
    },
  },
});

export const userGroupsActions = userGroupsSlice.actions;

export default userGroupsSlice.reducer;
